module.exports = __webpack_public_path__ + "static/media/OBGYN-Obstetric History-2@3x.32cb8f7a.png";